<script setup lang="ts">
import { PrivacyPolicy } from '@/components';

definePageMeta({
  layout: 'onboarding',
  auth: false,
});
</script>

<template>
  <v-container class="d-flex justify-center pa-0 mt-5">
    <PrivacyPolicy :show-header="true" :is-onboarding="false" />
  </v-container>
</template>
